import { useCallback, useEffect, useRef, useState } from 'react'

export function useChatThreadSpeech() {
  const [speechOpen, setSpeechOpen] = useState(false)
  const utterRef = useRef(null)
  const canSpeak = useRef(false)

  useEffect(() => {
    canSpeak.current = typeof window !== 'undefined' && 'speechSynthesis' in window
  }, [])

  const stopSpeech = useCallback(() => {
    if (!canSpeak.current) return
    try {
      window.speechSynthesis.cancel()
    } catch {
      // No-op
    } finally {
      utterRef.current = null
      setSpeechOpen(false)
    }
  }, [])

  useEffect(() => () => stopSpeech(), [stopSpeech])

  const startSpeech = useCallback((text) => {
    if (!text || !canSpeak.current) return
    try {
      window.speechSynthesis.cancel()
      const utter = new SpeechSynthesisUtterance(text)
      utterRef.current = utter
      setSpeechOpen(true)
      utter.onend = () => {
        if (utterRef.current !== utter) return
        utterRef.current = null
        setSpeechOpen(false)
      }
      utter.onerror = () => {
        if (utterRef.current !== utter) return
        utterRef.current = null
        setSpeechOpen(false)
      }
      window.speechSynthesis.speak(utter)
    } catch {
      utterRef.current = null
      setSpeechOpen(false)
    }
  }, [])

  return { speechOpen, startSpeech, stopSpeech }
}
